<template>
  <gather :height='height' :width='width' :type='"water"'></gather>
</template>

<script>
import gather from './gather'
export default {
  props:{
    width:Number,
    height:Number
  },
  components:{gather}
}
</script>

<style>

</style>
